var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57736 1.66663C11.6462 1.66663 13.3334 3.32496 13.3334 5.36663V9.35829H8.24621C7.88162 9.35829 7.59335 9.64163 7.59335 9.99996C7.59335 10.35 7.88162 10.6416 8.24621 10.6416H13.3334V14.625C13.3334 16.6666 11.6462 18.3333 9.5604 18.3333H5.43128C3.35401 18.3333 1.66675 16.675 1.66675 14.6333V5.37496C1.66675 3.32496 3.36248 1.66663 5.43976 1.66663H9.57736ZM15.4502 7.12513C15.7002 6.86679 16.1086 6.86679 16.3586 7.11679L18.7919 9.54179C18.9169 9.66679 18.9836 9.82513 18.9836 10.0001C18.9836 10.1668 18.9169 10.3335 18.7919 10.4501L16.3586 12.8751C16.2336 13.0001 16.0669 13.0668 15.9086 13.0668C15.7419 13.0668 15.5752 13.0001 15.4502 12.8751C15.2002 12.6251 15.2002 12.2168 15.4502 11.9668L16.7836 10.6418H13.3336V9.35846H16.7836L15.4502 8.03346C15.2002 7.78346 15.2002 7.37513 15.4502 7.12513Z",
    fill: "#0469FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.40a030f0af34fffedd54014f92dd88a6.svg";
export { ForwardRef as ReactComponent };